import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="min-h-screen flex flex-col" data-id="element-91">
      <Header data-id="element-92" />
      <main className="flex-grow pt-[88px]" data-id="element-93">{children}</main>
      <Footer data-id="element-94" />
    </div>;
}